/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_5_PInputs */

const en_terms_5_p = /** @type {(inputs: Terms_5_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You own what you put into Bystep and what it generates for you. You grant us a licence to store and process it only to provide the service. We do not claim any rights to your codebase.`)
};

const id_terms_5_p = /** @type {(inputs: Terms_5_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kamu memiliki apa yang kamu masukkan ke Bystep dan apa yang dihasilkan untukmu. Kamu memberi kami lisensi untuk menyimpan dan memprosesnya hanya demi menyediakan layanan. Kami tidak mengklaim hak apa pun atas codebase-mu.`)
};

/**
* | output |
* | --- |
* | "You own what you put into Bystep and what it generates for you. You grant us a licence to store and process it only to provide the service. We do not claim a..." |
*
* @param {Terms_5_PInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const terms_5_p = /** @type {((inputs?: Terms_5_PInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_5_PInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_terms_5_p(inputs)
	return en_terms_5_p(inputs)
});